export enum SupportStatus {
  NO_RESP = 1,
  PARTIAL_SUPPORT,
  REJECT_PROVIDE,
  ALL_LOST,
  FREEZED,
  PROVIDED_NEXT_ADDRESS,
  FULL_PROVIDED,
}

export type EntityListResp = {
  name: string;
  logo: string;
  twitterUrl: string;
  tgUrl: string;
  supportStatus: SupportStatus;
  blocked: string;
  unblocked: string;
  blockList: Array<{ time: string; amount: string }>;
  bannedAddressCount: number;
  reportedAddressCount: number;
  contributors: number;
  reportsCount: number;
  estimatedBountyAmount: string;
  awaitingResponseTime: string;
  lastTransactionTime: number;
  received: string;
  lostFund: string;
  awaitingResponseFund: string;
  firstReporter: string;
  resiResipient: string;
  backOnChainFunds: string;
};

export type HackerDataList = Array<{
  address: string;
  holdingValue: string;
  lastActivity: number;
  viewUrl: string;
  chain: string;
}>;

export type HackerAddressListResp = {
  dataList: HackerDataList;
  pageInfo: {
    totalPage: number;
    totalNum: number;
    pageNo: number;
    pageSize: number;
  };
};
